import { Record } from 'immutable'
import { EntityAccessType, EntityAccessValue } from './enums'

export interface IEntityAllow {
  readonly authenticatorId: string
  readonly name: string
  readonly type: EntityAccessType
  readonly value: EntityAccessValue
  readonly hasChanged: boolean
  readonly isAdded: boolean
}

const EntityAllowRecord = Record({
  authenticatorId: '',
  name: '',
  type: EntityAccessType.Property,
  value: EntityAccessValue.Unrestricted,
})

export class EntityAllow extends EntityAllowRecord implements IEntityAllow {
  public static fromJS(initialState?: Partial<IEntityAllow>) {
    return new EntityAllow(initialState)
  }

  public readonly authenticatorId: string
  public readonly name: string
  public readonly type: EntityAccessType
  public readonly value: EntityAccessValue
  public readonly hasChanged: boolean
  public readonly isAdded: boolean

  constructor(props?: Partial<EntityAllow>) {
    props ? super(props) : super()
  }
}
